import ConstantesTabla from "../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./concursoPS.scss";
import { Link } from "react-router-dom";
const ConsModSolicitudesL = (object) => {
  const navigate = useNavigate();
  //Para JC: En el archivo que  te envie (pruebas puestos extremadura 26-9-2023.sql) se identifican diferentes querys en las que se hace referencia
  //en que cuando el concurso tiene adscripcion L y tipo de convocatoria M llama a puestos, si el tipo de convocatoria es I llama a centros, si no es
  //ni I ni M llama a centros también pero con una query distinta
  
  const anexos = [
    {
      id: 1,
      nombre: "Anexo I.1 (Solicitud de participación)",
    },
    {
      id: 2,
      nombre: (
        <>
          <p className="mt-2">Anexo I.2 (Peticiones de destino)</p>
          <div className="d-flex flex-column">
            <i className="fa-solid fa-caret-right my-2">
              {" "}
              {object.tipoConvocatoria === "M" ?
                (<>
                  <Link
                    to={`/seleccionPuestos/${object.codConcurso}/${object.xSolicitud}`}
                    state={{ adscripcion: "L", tipoConvocatoria: object.tipoConvocatoria }}
                    className="fw-light"
                    role="link"
                    title="Anexo I.2"
                    aria-label="Anexo I.2"
                    tabIndex={0}

                    //TODO: pasar state cuidao
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        navigate(`/seleccionPuestos/${object.codConcurso}/${object.xSolicitud}`)
                      }
                    }}
                  >
                    Grabación de puestos
                  </Link>
                </>) :
                (<>
                  <Link
                    to={`/seleccionCentros/${object.codConcurso}/${object.xSolicitud}`}
                    state={{ adscripcion: "L", tipoConvocatoria: object.tipoConvocatoria }}
                    className="fw-light"
                    role="link"
                    title="Anexo II.2"
                    aria-label="Anexo II.2"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        navigate(`/seleccionCentros/${object.codConcurso}/${object.xSolicitud}`)
                      }
                    }}
                  >
                    Grabación de centros
                  </Link>
                </>)}

            </i>
            <i className="fa-solid fa-caret-right my-2">
              {" "}

              <Link
                to={`/centrosOrdenPreferencia/${object.codConcurso}/${object.xSolicitud}`}
                state={{ adscripcion: "F", tipoConvocatoria: object.tipoConvocatoria }}
                className="fw-light"
                role="link"
                    title="Anexo I.2"
                    aria-label="Anexo I.2"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        navigate(`/centrosOrdenPreferencia/${object.codConcurso}/${object.xSolicitud}`)
                      }
                    }}
              >
                Visualización de centros seleccionados y reordenar preferencias
              </Link>
            </i>
          </div>
        </>
      ),
    },
    {
      id: 3,
      nombre: "Anexo I.3 (Alegaciones de méritos)",
    },
  ];

  const columnas = [ConstantesTabla.columnasTablaAnexos];
  columnas.push({
    name: "Modificar",
    grow: 1.1,
    center: true,
    cell: (row) =>
      row.id === 1 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          role="button"
          title="Anexo I.1"
          aria-label="Anexo I.1"
          onClick={() =>
            navigate(`/anexoi_1/${object.codConcurso}/${object.xSolicitud}`)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/anexoi_1/${object.codConcurso}/${object.xSolicitud}`)
            }
          }}
          tabIndex={0}
        ></i>
      ) : row.id === 3 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          role="button"
          title="Anexo I.3"
          aria-label="Anexo I.3"
          onClick={() =>
            navigate(`/anexoi_3/${object.codConcurso}/${object.xSolicitud}`,{state:{numSol:object.numSol}})
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/anexoi_3/${object.codConcurso}/${object.xSolicitud}`,{state:{numSol:object.numSol}})
            }
          }}
          tabIndex={0}
        ></i>
      ) : null,
  });
  useEffect(() => { }, []);
  return (
    <>
      <DataTable
        className="table-responsive"
        columns={columnas}
        data={anexos}
        pagination
        paginationComponentOptions={ConstantesTabla.paginacionOpt}
        noDataComponent={<span>No se encontró ninguna solicitud</span>}
        customStyles={ConstantesTabla.customStyles}
        fixedHeader
        fixedHeaderScrollHeight="600px"
        style={{ marginTop: "20px" }}
      />
    </>
  );
};

export default ConsModSolicitudesL;
